import * as React from 'react';
import { useEffect, useState } from 'react';

interface IProps {
  score: number;
  maxScore: number;
  index: number;
}

export const WaveScore = (props: IProps) => {
  const [radius] = useState(25);
  const [centerX] = useState(25);
  const [centerY] = useState(0);
  const [angle1, setAngle1] = useState(0);
  const [angle2, setAngle2] = useState(0);

  const { score, maxScore, index } = props;

  const halfMaxScore = maxScore / 2;

  const index1 = index + '-1';
  const index2 = index + '-2';

  useEffect(() => {
    if (score > halfMaxScore) {
      setAngle1(0 * Math.PI);
      setAngle2((((halfMaxScore - (score - halfMaxScore)) / halfMaxScore)) * Math.PI);
    } else {
      setAngle1(((halfMaxScore - score) / halfMaxScore) * Math.PI);
      setAngle2(1 * Math.PI);
    }


  }, [props.score]);

  return (
    <div className="wave-score  ui-toolkit"
      style={{ width: '126px', marginRight: '12px' }}>
      {score > 0 && (
        <svg viewBox="0,0 50,26"
          style={{ transform: 'rotate(180deg) scaleX(-1)', marginRight: '30px' }}>
          <mask id={`myMask${index1}`}>
            <path
              id={`pieBig${index1}`}
              fill="white"
              d={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(Math.PI))},${centerY + (radius * Math.sin(Math.PI))} z`}
            />
          </mask>

          <image
            className="score-image"
            href="/assets/logo-shape-gray.png"
            width="100%"
          />

          <image
            className="score-image"
            href="/assets/logo-shape-beach.png"
            mask={`url(#myMask${index1})`}
            width="100%"
          />

          <animate
            href={`#pieBig${index1}`}
            xlinkHref={`#pieBig${index1}`}
            begin="1s"
            attributeName="d"
            dur="1s"
            from={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(Math.PI))},${centerY + (radius * Math.sin(Math.PI))} z`}
            to={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(angle1))},${centerY + (radius * Math.sin(angle1))} z`}
            fill="freeze"
          />

        </svg>
      )}
      {score > 0 && (
        <svg viewBox="0,0 50,26"
          style={{ marginLeft: '38px' }}>
          <mask id={`myMask${index2}`}>
            <path
              id={`pieBig${index2}`}
              fill="white"
              d={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(Math.PI))},${centerY + (radius * Math.sin(Math.PI))} z`}
            />
          </mask>

          <image
            className="score-image"
            href="/assets/logo-shape-gray.png"
            width="100%"
          />

          <image
            className="score-image"
            href="/assets/logo-shape-wheat.png"
            width="100%"
            mask={`url(#myMask${index2})`}
          />

          <animate
            href={`#pieBig${index2}`}
            xlinkHref={`#pieBig${index2}`}
            attributeName="d"
            begin="2s"
            dur="1s"
            from={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(Math.PI))},${centerY + (radius * Math.sin(Math.PI))} z`}
            to={`M${centerX},${centerY} 
                            L${centerX - centerX},${centerY}  
                            A${radius},${radius} 1 1,0 ${centerX + (radius * Math.cos(angle2))},${centerY + (radius * Math.sin(angle2))} z`}
            fill="freeze"
          />

        </svg>
      )}
    </div>
  );
};
